import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgAttach = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 23.291 23.292"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke="#1C274C" fill="none" fillRule="evenodd">
      <path
        d="M.813 11.646c0-5.108 0-7.66 1.586-9.249C3.986.813 6.537.813 11.646.813c5.108 0 7.66 0 9.245 1.586 1.588 1.588 1.588 4.14 1.588 9.247 0 5.108 0 7.66-1.587 9.246-1.585 1.588-4.14 1.588-9.246 1.588-5.108 0-7.66 0-9.249-1.588C.813 19.307.813 16.752.813 11.646Z"
        strokeWidth={1.625}
      />
      <path
        d="m11.813 16.813 5-5M13.46 8.212l-4.95 5.152a1.217 1.217 0 0 0 0 1.696 1.16 1.16 0 0 0 1.664 0l4.95-5.152a2.434 2.434 0 0 0 0-3.393 2.32 2.32 0 0 0-3.329 0l-4.95 5.15a3.651 3.651 0 0 0 0 5.093 3.481 3.481 0 0 0 4.993 0"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
const Memo = memo(SvgAttach);
export default Memo;
